<template>
    <div class="grid grid--padding">
        <div class="about">
            <h2 class="about__title">{{ $t('about.title') }}</h2>
            <div v-html="$t('about.text.game')" class="about__text"></div>
            <h2 class="about__title">{{ $t('about.subtitle') }}</h2>
            <div v-html="$t('about.text.gameplay')" class="about__text"></div>

            <router-link :to="{name: 'game-options'}" class="btn btn--primary">
                {{ $t('button.next') }}
            </router-link>
            <router-link :to="{name: 'home'}" class="btn">
                {{ $t('button.cancel') }}
            </router-link>

            <div class="about__footer">
                <img src="@/assets/images/logo/EU-logo.svg" alt="EU logo" class="about__logo" />
                <img src="@/assets/images/logo/ESI-logo.svg" alt="ESI logo" class="about__logo" />
                <img src="@/assets/images/logo/ESF-logo.svg" alt="ESF logo" class="about__logo" />
                <img src="@/assets/images/logo/raSTEMo-logo.svg" alt="raSTEMo logo" class="about__logo" />
                <img src="@/assets/images/logo/Nacionalna-zaklada-za-razvoj-civilnog-drustva-logo.svg" alt="Nacionalna zaklada za razvoj civilnog društva logo" class="about__logo" />
                <img src="@/assets/images/logo/Vlada-RH-Ured-za-udruge-logo.svg" alt="Vlada RH Ured za udruge logo" class="about__logo" />
            </div>
        </div>
    </div>
</template>
